import React from 'react';
import PropTypes from 'prop-types';
import {useNeuroMessages} from '@ignitesales/neuro-application';

const DialogueClientLogo = ({ alt, className }) => {
    const { getMessage } = useNeuroMessages();

    return (
        <img src={ getMessage('logo')} alt={alt || 'Logo'} className={className} />
    );
};
DialogueClientLogo.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string
};

export default DialogueClientLogo;
